module.exports = global.config = {
    HOn: {
        CPF: {
            NR: "95673482787"
        
        }
        
    }
    
};